import React from 'react';

const PrivacyPolicy = () => {
  return (
    <>
      <h3 style={{ textAlign: 'center' }}>Privacy Policy</h3>

      <h4 style={{ textAlign: 'center' }}>last updated : 20&nbsp;March 2024</h4>

      <h4>
        <strong>A1.1 Introduction</strong>
      </h4>
      <p>
        This Policy outlines how we manage personal information and safeguard
        the privacy of our clients.
      </p>
      <h4>
        <strong>A1.2 References</strong>
      </h4>
      <p>This Policy has also been developed with reference to:</p>
      <ul>
        <li>
          The&nbsp;<em>Privacy Act</em>&nbsp;1988 (Cth) (
          <strong>
            <em>PrivacyAct</em>
          </strong>
          );
        </li>
        <li>
          The Australian Privacy Principles (<strong>APPs</strong>), contained
          within the&nbsp;<em>Privacy Act</em>; and
        </li>
        <li>The Australian Privacy Principles Guidelines (July 2019).</li>
      </ul>
      <p>
        <strong>A1.3 What personal information is collected?</strong>
      </p>
      <p>
        We only collect personal information that is reasonably necessary for us
        to provide our clients with financial services and to administer
        them.&nbsp;The kind of personal information we collect and hold will
        depend upon the type of services requested by our clients and may
        include:
      </p>
      <ul>
        <li>
          information given by our clients or their advisers or service
          providers when they request a service from us. This information may
          include an individual’s name, date of birth, address, contact details
          and relevant identification documents;
        </li>
        <li>
          communications between us and our clients’ financial, legal or other
          adviser, including their broker or other agent;
        </li>
        <li>transactional information about the use of a service;</li>
        <li>
          in some cases, sensitive information obtained with an individual’s
          consent or otherwise where required or permitted by law (e.g. in
          relation to anti-money laundering laws);
        </li>
        <li>
          information such as an individual’s name, address and date of birth
          where an investor or borrower has listed that individual as a
          beneficial owner or other related party in connection with the
          investment or loan;
        </li>
        <li>
          information regarding website interactions with us (eg the sections or
          features of our website that an individual has visited or used). This
          information will be anonymous unless an individual is logged into our
          site.
        </li>
      </ul>
      <p>
        <strong>A1.4 How is personal information collected?</strong>
      </p>
      <p>We collect personal information in a number of ways including:</p>
      <ul>
        <li>
          directly from individuals and clients (including via financial, legal,
          or other advisers, or broker or other agents connected to a client),
          such as when completing an application form
        </li>
        <li>
          from an investor or borrower where they have nominated a certain
          individual as a beneficial owner or other related person inconnection
          with the investment or loan;
        </li>
        <li>
          from publicly or commercially available sources for the purpose of
          complying with customer due diligence obligations under relevant
          legislation (e.g. anti-money laundering laws
        </li>
      </ul>
      <p>
        <strong>A1.5 What if certain information is not provided?</strong>
      </p>
      <p>
        If we are provided with an incomplete application, we may not be able to
        provide any services until the application is complete.
      </p>
      <p>
        If a client chooses not to disclose their Tax File Number (
        <strong>TFN</strong>), TFN exemption or Australian Business Number (
        <strong>ABN</strong>), we may have to deduct tax at the highest marginal
        rate (plus the Medicare levy) from distributions or income payments.
      </p>
      <p>
        If an individual chooses not to disclose their account details or
        correctly answer verification questions, we may not be able to provide
        services requested.
      </p>
      <h4>
        <strong>A1.6 How do we use and disclose personal information?</strong>
      </h4>
      <p>
        We may collect, use and disclose an individual’s personal information
        for the primary purpose of providing the services requested by our
        clients, as well as for related purposes such as:
      </p>
      <ul>
        <li>
          to verify an individual’s identity or transactions which our client
          may enter into with us (including the identities of third parties
          connected with a client’s application for products and services, such
          as beneficial owners, where applicable);
        </li>
        <li>to process applications for our services;</li>
        <li>to administer and manage the provision of our services;</li>
        <li>
          to respond to queries, complaints or to provide general customer
          services;
        </li>
        <li>
          to provide our client, their asset consultant, custodian,
          administrator or legalor other adviser details of their investments;
        </li>
        <li>
          to provide offers of other services and to improve and personalise our
          products and services;
        </li>
        <li>
          to comply with laws and regulatory requirements, including anti-money
          laundering, financial services and taxation laws, or complying with
          any request made by a governmental authority in connection with legal
          proceedings or the prevention or detection of fraud and crime;
        </li>
        <li>to comply with our risk management policies and procedures;</li>
        <li>to conduct service and market research;</li>
        <li>to train our staff; or</li>
      </ul>
      <p>We may disclose personal information to;</p>
      <ul>
        <li>our client’s asset consultants or other adviser;</li>
        <li>
          professional service firms that provide services to us, such as,
          legal, audit or data/ information services;
        </li>
        <li>
          electronic identity verification service providers, in order for
          identity information (about an individual or related persons connected
          with a client’s investment/product to be verified against relevant
          government and other databases, for the purpose of complying
          withanti-money laundering laws); and
        </li>
        <li>otherwise in accordance with this policy and the APPs.</li>
      </ul>
      <p>
        <strong>A1.7 Overseas disclosures</strong>
      </p>
      <p>
        We may disclose personal information collected in Australia to
        recipients in foreign countries, but only do so where we have disclosed
        to users of our website the location of those recipients; and in
        circumstances where the overseas recipient is subject to a law, or
        binding scheme, that hasthe effect of protecting the information in a
        way that, overall, is at least substantially similar to the way the APPs
        protect the information, and mechanisms can be accessed by the
        individual to enforce that protection of thelaw or binding scheme; or in
        circumstances where we enter into an enforceable contractual arrangement
        with the overseas recipient that requires the recipient to handle the
        personal information in accordance with the APPs (other than
        APP1).&nbsp;In some cases, we may utilise 'Cloud' storage solutions for
        data storage purposes, and the relevant servers may be located overseas.
      </p>
      <p>
        <strong>A1.8 Use of service providers</strong>
      </p>
      <p>
        We may contract out some of our administrative and support functions
        such as mailing, settlement services, unit registry services, document
        and data storage, background checking or identity verification to
        external service providers from time to time. Only information necessary
        forthe service provider to carry out their function will be provided and
        will be subject to confidentiality clauses in the relevant services
        agreement.
      </p>
      <h4>
        <strong>A1.9 Keeping us up-to-date</strong>
      </h4>
      <p>
        Personal information such as contact details may change fromtime-to-time
        and we ask that our clients and individuals keep us informed of any
        changes by notifying us.
      </p>
      <p>
        Where information has been previously provided about another person
        related to a client’s investment/product (such as a beneficial
        owner),and the information is no longer current, the client must provide
        up-to-date information.
      </p>
      <p>
        Changes to some details, such as a change of name, may require
        additional documentation to verify the change. Additionally, some
        changes may be required to be made on a specific form.
      </p>
      <h4>
        <strong>A1.10 Storage and security of information</strong>
      </h4>
      <p>
        We store personal information in a combination of computer storage
        facilities, paper-based files and other records.&nbsp;These are held on
        our premises and systems aswell as offsite using 'Cloud' service
        providers for data storage and management purposes, which may be located
        overseas. We maintain effective control of the information under
        contractual arrangements.
      </p>
      <p>
        We will take reasonable steps to protect personal information from loss,
        interference or misuse, and unauthorised access, modification or
        disclosure, and that any service provider we rely on takes similar
        steps.
      </p>
      <p>
        Where personal information is no longer requiredto be retained, we will
        take such steps as are reasonable in the circumstances to de-identify
        the information or put it beyond use.
      </p>
      <h4>
        <strong>A1.11 Openness</strong>
      </h4>
      <p>
        This document sets out our policy on the management of personal
        information and is made freely available on our website, or in hardcopy
        if requested.
      </p>
      <h4>
        <strong>A1.12 Access and correction</strong>
      </h4>
      <p>
        Generally, we provide individuals with access to their personal
        information that we hold, unless a particular exception applies, such as
        where:
      </p>
      <ul>
        <li>it would be unlawful to provide the information</li>
        <li>
          providing access would be likely to prejudice an investigation of
          possible unlawful activity;
        </li>
        <li>
          the information is relevant to legal proceedings and would not be
          accessible in the normal discovery process;
        </li>
        <li>
          giving access would have an unreasonable impacton the privacy of other
          individuals;
        </li>
        <li>
          it would pose a serious and imminent threat tothe life or health of
          any individual; or
        </li>
        <li>the request is frivolous or vexatious.</li>
      </ul>
      <p>
        If a request for access would divulge a commercially sensitive
        decision-making process, then we may provide an explanation rather than
        direct access to the information.
      </p>
      <p>
        If we become aware that the personal information we hold about an
        individual is inaccurate, incomplete, misleading or irrelevant, then we
        will take reasonable steps to amend it.&nbsp;If we receive a request
        from an individual to correct their information, then we will seek to
        correct it within 30 days.&nbsp;If we disagree with an individual about
        the accuracy, completeness or currency of our records, then they have
        the right to request that we note their disagreement on those records.
      </p>
      <h4>
        <strong>A1.13 Identifiers</strong>
      </h4>
      <p>
        We do not use any government-issued identifiers (such asTFNs, Medicare
        numbers and Drivers Licence numbers) for use as our own identifier for
        individuals.&nbsp;Instead, we create our own unique identifiers such as
        investor numbers and account numbers areused to identify individuals.
      </p>
      <h4>
        <strong>A1.14 Anonymity and pseudonymity</strong>
      </h4>
      <p>
        Given legal requirements on financial institutions to identify their
        customers, in most situations we cannot allow transactions onthe basis
        of anonymity (including the use of a pseudonym).&nbsp;Access to our
        public website, may be done anonymously, or in the case of general
        enquiries, using a pseudonym. However, we may not be able to respond to
        queries unless we are provided with certain information.
      </p>
      <h4>
        <strong>A1.15 Digital Marketing</strong>
      </h4>
      <p>
        We will not use personal information for direct marketing purposes
        unless:
      </p>
      <ul>
        <li>
          we have obtained consent, or the individual would reasonably expect us
          to use their personal information for direct marketing purposes; and
        </li>
        <li>
          we have provided the individual with a simple means to 'opt-out' from
          receiving direct marketing; and
        </li>
        <li>we have not received such a request from the individual.</li>
      </ul>
      <p>
        We will not use any sensitive information for directmarketing purposes.
      </p>
      <p>
        <strong>A1.16 Use of our website</strong>
      </p>
      <h4>
        <em>A1.16.1 Website analytics</em>
      </h4>
      <p>
        Our web analytics providers use "cookies" and insome cases "clear
        gifs/web beacons" to collect information.
      </p>
      <h4>
        <em>A1.16.2 Cookies</em>
      </h4>
      <p>
        Cookies are pieces of information that are transferred to a computer
        when a person visit a website so that sites can record usage and, in
        some cases, provide tailored content or targeted advertising.&nbsp;Most
        web browsers are set to accept cookies, orthey can be
        rejected.&nbsp;However, if allcookies are rejected, some parts of the
        website may be inaccessible.
      </p>
      <h4>
        <em>A1.16.3 Clear gifs</em>
      </h4>
      <p>
        Clear gifs (also known as web beacons) are used in combination with
        cookies to help us understand how visitors interact with
        ourwebsite.&nbsp;A clear gif is typically a transparent graphic image
        (usually 1 pixel x 1 pixel) that is placed on a site. The use of a clear
        gif allows us to measure the actions of the visitor opening the page
        that contains the cleargif.
      </p>
      <p>
        <strong>A1.17 Contacting us</strong>
      </p>
      <p>
        The Compliance Officer may be contacted regarding anyquestions in
        relation to this Policy:
      </p>
      <p>Nick Reeves</p>
      <p>contact@bluesana.com.au</p>
      <p>
        <strong>A1.18 Complaints about privacy</strong>
      </p>
      <p>
        Clients may raise any concerns about any breach or potential breach of
        their privacy, by contacting the Compliance Officer and we will
        makeevery effort to resolve the complaint internally.
      </p>
      <p>To make a complaint:</p>
      <ul>
        <li>Write to the Compliance Officer at contact@bluesana.com.au</li>
        <li>
          We will attempt to respond within 30 days fromreceipt of a request
        </li>
      </ul>
      <p>
        The complaint may also be taken to the Office of theAustralian
        Information Commissioner (<strong>OAIC</strong>)
      </p>
      <p>
        For more information on how to lodge a complaint with the OAIC, please
        contact the OAIC hotline service on 1300 363 992 or email
        enquiries@oaic.gov.au
      </p>
      <p>
        <strong>A1.19 Changes to our Privacy Policy</strong>
      </p>
      <p>
        We may make changes to this policy from time to time for anyreason and
        we will update our website in a timely manner.
      </p>
      <p>
        <strong>A1.20 Training &amp; Awareness</strong>
      </p>
      <p>
        The Compliance Officer is responsible for ensuring that all Staff are
        aware of the requirements in this Policy.
      </p>
      <p>
        <strong>A1.21 Non-compliance</strong>
      </p>
      <p>
        Instances of non-compliance with this Policy must be reported under our
        Incidents &amp; Breaches Policy &amp; Process.&nbsp;Intentional
        non-compliance is considered serious and may result in disciplinary
        action including dismissal.
      </p>
      <p>
        <strong>A1.22 Reporting</strong>
      </p>
      <p>
        The Compliance Officer must report to the Board periodically on any
        privacy complaints under this policy as well as any instances of
        non-compliance.
      </p>
    </>
  );
};

export default PrivacyPolicy;
